import React from 'react';
import SideBarMobile from '../../../shared/templates/CategoryTemplate/category-sidebar-mobile';

function BlogsSideBarMobile(props) {
  return (<SideBarMobile {...props}
    section="blogs"
    searchTitle="Search Blogs"
    createNewTitle="New Blog"
    filterList={[
      { name: 'keywords', value: 'Enter Keywords' },
    ]}
  />);
}

export default BlogsSideBarMobile;